import React from 'react';
import { Link } from 'react-router-dom';
import Clearfix from 'react-bootstrap/lib/Clearfix';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import AMPPage from '../AMPPage';
import AMPPageSection from '../AMPPageSection';
import AMPPodcastReadySection from '../AMPPodcastReadySection';
import Img from '../Img';
import AMPTrackedLink from '../AMPTrackedLink';
import PressSection from '../PressSection';
import { AppStoreButton, PlayStoreButton } from '../AppDownloadButtons';
import HeaderSection from './components/HeaderSection';
import styles from './styles.sass';

const IMG_PREFIX = 'https://d12xoj7p9moygp.cloudfront.net/images/';

const AMPHomePage = props => {
  const isAmp = props.context && props.context.isAmpRoute;
  return (
    <AMPPage isAmpRoute={isAmp}>
      <HeaderSection />
      <div className={styles.features}>
        <h2>A few of Anchor's best features:</h2>
        <div className={styles.featuresRow}>
          <div className={`${styles.featuresPanel} ${styles.featureHosting}`}>
            <Img
              isAmp={isAmp}
              alt="Unlimited Free Hosting"
              src={`${IMG_PREFIX}free-hosting-home.png`}
              withRetina
              layout="fixed"
              width={126}
              height={110}
            />
            <Link to="/features#unlimitedHosting">
              UNLIMITED FREE HOSTING →
            </Link>
            <p>
              We don’t believe in charging creators to make or store their
              content. No storage limits, no trial period, no catch.
            </p>
          </div>
          <div
            className={`${styles.featuresPanel} ${styles.featureDistribution}`}
          >
            <Img
              isAmp={isAmp}
              alt="Podcast Distribution"
              src={`${IMG_PREFIX}distribution-home.png`}
              withRetina
              layout="fixed"
              width={132}
              height={140}
            />
            <Link to="/features#distribution">ONE-CLICK DISTRIBUTION →</Link>
            <p>
              Make your podcast available everywhere people listen (including
              Apple Podcasts, Google Podcasts, and Spotify), with just one
              click.
            </p>
          </div>
          <div className={`${styles.featuresPanel} ${styles.featureMonetize}`}>
            <Img
              isAmp={isAmp}
              alt="Monetize Your Podcast"
              src={`${IMG_PREFIX}monetize-sponsorships-home-2.png`}
              withRetina
              layout="fixed"
              width={90}
              height={90}
            />
            <Link to="/features#monetize">MONETIZE YOUR PODCAST →</Link>
            <p>
              Get paid for your plays by beloved brands we’ll match with your
              show, or collect monthly payments from your listeners. Or both!
            </p>
          </div>
          <div className={`${styles.featuresPanel} ${styles.featureSocial}`}>
            <Img
              isAmp={isAmp}
              alt="Podcast With Friends"
              src={`${IMG_PREFIX}rwf-home.png`}
              withRetina
              layout="fixed"
              width={152}
              height={144}
            />
            <Link to="/features#podcastWithFriends">
              PODCAST WITH FRIENDS →
            </Link>
            <p>
              Record with guests or cohosts anywhere in the world, or collect
              voice messages from your listeners to include in your episodes.
            </p>
          </div>
          <div className={`${styles.featuresPanel} ${styles.featureAnalytics}`}>
            <Img
              isAmp={isAmp}
              alt="Straightforward Analytics"
              src={`${IMG_PREFIX}analytics-home.png`}
              withRetina
              layout="fixed"
              width={340}
              height={118}
            />
            <Link to="/features#analytics">STRAIGHTFORWARD ANALYTICS →</Link>
            <p>
              See at a glance how your podcast episodes are doing over time, so
              you can understand and grow your audience.
            </p>
          </div>
          <div className={`${styles.featuresPanel} ${styles.featureAnywhere}`}>
            <Img
              isAmp={isAmp}
              alt="Record From Anywhere"
              src={`${IMG_PREFIX}record-home.png`}
              withRetina
              layout="fixed"
              width={109}
              height={147}
            />
            <Link to="/features#recordAnywhere">RECORD FROM ANYWHERE →</Link>
            <p>
              Anchor’s mobile apps, iPad app, and desktop platform make it easy
              to capture audio anywhere, anytime.
            </p>
            <div>
              <AppStoreButton height={30} />
              <PlayStoreButton height={30} />
            </div>
          </div>
        </div>
      </div>
      <AMPPageSection id="free" color="gray">
        <PressSection isAmp={isAmp} />
        <div className={styles.featuredTweets}>
          <div className={styles.leftTweet}>
            <Img
              isAmp={isAmp}
              alt="a tweet about Anchor"
              src={`${IMG_PREFIX}home-featured-tweet-3-2.png`}
              withRetina
              width={384}
              height={142}
              layout="responsive"
            />
          </div>
          <div className={styles.centerTweet}>
            <Img
              isAmp={isAmp}
              alt="a tweet about Anchor"
              src={`${IMG_PREFIX}home-featured-tweet-1-2.png`}
              withRetina
              width={399}
              height={212}
              layout="responsive"
            />
          </div>
          <div className={styles.rightTweet}>
            <Img
              isAmp={isAmp}
              alt="a tweet about Anchor"
              src={`${IMG_PREFIX}home-featured-tweet-2-2.png`}
              withRetina
              width={384}
              height={142}
              layout="responsive"
            />
          </div>
        </div>
      </AMPPageSection>
      <AMPPodcastReadySection />
    </AMPPage>
  );
};

export default AMPHomePage;
